<app-layout-crud-index (settings)="openSettings()" customClass="bg-home-cards">
    <div class="home-dashboard"
        [class.dark-mode]="darkMode"
        [class.layout-logo]="showsBranchLogo"
        [class.layout-highlights]="highlightsExpanded"
        table fxLayout="column"
        fxLayoutAlign="center center">
        <div class="dashboard-container" fxLayout="column"
            fxLayoutAlign="start stretch" fxLayoutGap="10px">

            <header class="dashboard-header">
                <div class="welcome-content">
                    <h1>Olá, <span>{{userFirstName}}</span> 👋</h1>
                    <p>Painel administrativo WAZIR ERP — escolha um módulo para começar.</p>
                </div>

                <div class="header-actions">
                    <label class="module-search">
                        <mat-icon>search</mat-icon>
                        <input type="text"
                            placeholder="Buscar módulo..."
                            [value]="moduleSearch"
                            (input)="setModuleSearch($any($event.target).value)">
                    </label>
                    <button type="button" class="theme-button"
                        aria-label="Trocar modo dos cards"
                        [matTooltip]="layoutModeLabel"
                        [matMenuTriggerFor]="layoutMenu">
                        <mat-icon>{{layoutModeIcon}}</mat-icon>
                    </button>
                    <mat-menu #layoutMenu="matMenu">
                        <button mat-menu-item type="button" (click)="setLayoutMode('modules')">
                            <mat-icon>{{layoutMode === 'modules' ? 'check' : 'grid_view'}}</mat-icon>
                            <span>Módulos</span>
                        </button>
                        <button mat-menu-item type="button" (click)="setLayoutMode('logo')">
                            <mat-icon>{{layoutMode === 'logo' ? 'check' : 'storefront'}}</mat-icon>
                            <span>Logo da filial</span>
                        </button>
                        <button mat-menu-item type="button" (click)="setLayoutMode('highlights')">
                            <mat-icon>{{layoutMode === 'highlights' ? 'check' : 'panorama'}}</mat-icon>
                            <span>Destaques</span>
                        </button>
                    </mat-menu>
                    <button type="button" class="theme-button"
                        aria-label="Alternar tema"
                        (click)="toggleTheme()">
                        <mat-icon>{{darkMode ? 'light_mode' : 'dark_mode'}}</mat-icon>
                    </button>
                </div>
            </header>

            <div class="section-heading" *ngIf="showsHighlights">
                <span>DESTAQUES</span>
                <div></div>
            </div>

            <div class="branch-logo-panel" *ngIf="showsBranchLogo">
                <img *ngIf="branchLogoUrl"
                    [src]="branchLogoUrl"
                    [alt]="branchTitle || 'Logo da filial'">
                <div *ngIf="!branchLogoUrl" class="no-slides-message">
                    <mat-icon>storefront</mat-icon>
                    <h3>Nenhum logo disponível</h3>
                    <p>Não há logo configurado para esta filial.</p>
                </div>
            </div>

            <!-- Destaques lado a lado -->
            <div class="carousel-wrapper" *ngIf="showsHighlights"
                fxLayoutAlign="center center">
                <div class="carousel-container" fxLayout="column"
                    fxLayoutAlign="start center">
                    <div class="carousel" [class.loading]="loading">
                        <div class="carousel-panels">
                            <div class="carousel-panel"
                                *ngFor="let slot of carouselSlots">
                                <div *ngIf="loading" class="carousel-loading">
                                    <mat-spinner diameter="40"></mat-spinner>
                                </div>

                                <div class="slide-container" *ngIf="!loading">
                                    <ng-container
                                        *ngIf="getSlideForSlot(slot) as slide; else noSlide">
                                        <div class="slide"
                                            [@carouselAnimation]="'active'">
                                            <div class="slide-image-container"
                                                (click)="navigateToSlideLink(getSlideIndexForSlot(slot))">
                                                <img *ngIf="slide.imageUrl"
                                                    [src]="slide.imageUrl"
                                                    [alt]="slide.title">
                                                <div *ngIf="!slide.imageUrl"
                                                    class="missing-image">
                                                    <mat-icon>image</mat-icon>
                                                    <p>Imagem não disponível</p>
                                                </div>
                                            </div>

                                            <div class="slide-caption"
                                                *ngIf="slide.title || slide.description">
                                                <h3 *ngIf="slide.title">{{slide.title}}</h3>
                                                <p *ngIf="slide.description">{{slide.description}}</p>
                                            </div>
                                        </div>
                                    </ng-container>

                                    <ng-template #noSlide>
                                        <div class="no-slides-message">
                                            <mat-icon>image_not_supported</mat-icon>
                                            <h3>Nenhuma imagem disponível</h3>
                                            <p>Não há destaque configurado para este espaço.</p>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div>

                        <div class="carousel-controls"
                            *ngIf="!loading && carouselSlides && carouselSlides.length > 2">
                            <button mat-mini-fab class="control-button prev"
                                (click)="prevSlide()">
                                <mat-icon>navigate_before</mat-icon>
                            </button>
                            <button mat-mini-fab class="control-button next"
                                (click)="nextSlide()">
                                <mat-icon>navigate_next</mat-icon>
                            </button>
                        </div>

                        <div class="carousel-indicators"
                            *ngIf="!loading && carouselSlides && carouselSlides.length > 2">
                            <button mat-mini-fab
                                *ngFor="let slide of carouselSlides; let i = index"
                                [class.active]="i === currentSlide"
                                (click)="setCurrentSlide(i)">
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Menu de navegação abaixo dos destaques -->
            <div class="menu-wrapper" *ngIf="showsModuleCards"
                fxLayout="column" fxLayoutAlign="start center">
                <div class="section-heading modules-heading">
                    <span>MÓDULOS</span>
                    <div></div>
                </div>
                <div class="menu-grid">
                    <div class="menu-card-item"
                        *ngFor="let card of pagedMenuCards">
                        <div class="menu-card"
                            [class.disabled]="!canEnableCard(card.role)"
                            [class.enabled]="canEnableCard(card.role)"
                            (click)="canEnableCard(card.role) && navigateTo(card.routerLink || card.action)">
                            <div class="card-icon-wrapper"
                                [style.backgroundColor]="canEnableCard(card.role) ? card.color : '#9e9e9e'">
                                <mat-icon>{{card.icon}}</mat-icon>
                            </div>
                            <div class="card-content">
                                <h3>{{card.title}}</h3>
                                <p>{{card.description}}</p>
                                <div *ngIf="shouldShowSoonBadge(card.role)"
                                    class="special-badge">EM BREVE</div>
                            </div>
                        </div>
                    </div>
                </div>

                <nav class="module-pagination"
                    *ngIf="filteredMenuCards.length > 0"
                    aria-label="Paginação dos módulos">
                    <span class="range-label">{{ moduleRangeLabel }}</span>
                    <button type="button"
                        aria-label="Página anterior"
                        [disabled]="currentModulePageIndex === 0"
                        (click)="goToModulePage(currentModulePageIndex - 1)">
                        <mat-icon>chevron_left</mat-icon>
                    </button>
                    <button type="button"
                        *ngFor="let page of modulePageNumbers"
                        [class.active]="page === currentModulePageIndex"
                        [attr.aria-label]="'Página ' + (page + 1)"
                        [attr.aria-current]="page === currentModulePageIndex ? 'page' : null"
                        (click)="goToModulePage(page)">
                        {{ page + 1 }}
                    </button>
                    <button type="button"
                        aria-label="Próxima página"
                        [disabled]="currentModulePageIndex >= moduleTotalPages - 1"
                        (click)="goToModulePage(currentModulePageIndex + 1)">
                        <mat-icon>chevron_right</mat-icon>
                    </button>
                </nav>
            </div>

        </div>
    </div>
</app-layout-crud-index>